export default (state, actions) => {
  return Object.assign({}, state, { app_version: actions.version });
};
